import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  LoadingContainer,
  Space,
  WebScrollView,
} from '@redlink/components/atoms';
import {
  ProfileEditSection,
  ProfileSettingSection,
  PreviewProfilePage,
} from '@redlink/components/pages';
import { PreviewContainer } from '@redlink/components/molecules';
import { useQuery, getPageProfileQuery } from '@redlink/services';

export const ProfilePage = memo(() => {
  const { styles } = useStyle();

  const {
    loading: getPageProfileIsBusy,
    data: {
      PageProfile: {
        fullname,
        emailAddress,
        avatar,
        bio,
        cellphoneNumber,
        address,
        pageName,
        tags = [],
        links = [],
        settings: { showQrCode, defaultTab, visibleTabs = [] } = {},
      } = {},
    },
  } = useQuery(getPageProfileQuery);

  return (
    <LoadingContainer
      isInitial
      isBusy={getPageProfileIsBusy}
      style={styles.container}
    >
      <WebScrollView>
        <View style={styles.bodyContainer}>
          <ProfileEditSection
            {...{ pageName }}
            data={{
              pageName,
              tags,
              links,
              emailAddress,
              cellphoneNumber,
              address,
              fullname,
              avatarId: avatar?.id,
              avatarUrl: avatar?.thumbnailUrl,
              bio,
            }}
          />
          <Space />
          <ProfileSettingSection
            {...{ pageName }}
            data={{
              defaultTab,
              visibleTabs,
              showQrCode,
            }}
          />
        </View>
      </WebScrollView>
      <PreviewContainer>
        <PreviewProfilePage {...{ pageName }} />
      </PreviewContainer>
    </LoadingContainer>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  bodyContainer: {
    // eslint-disable-next-line no-undef
    ...(!__MOBILE__ && { width: 432 }),
  },
}));
